export default {
  getUserAccessToken: (): string | null => localStorage.getItem('accessToken'),
  getUserId: (): string | null => localStorage.getItem('userId'),
  getRole: (): string | null => localStorage.getItem('role'),
  isSignedIn: (): boolean =>
    Boolean(
      localStorage.getItem('accessToken') &&
        localStorage.getItem('userId') &&
        localStorage.getItem('role')
    ),
  signIn: ({
    accessToken,
    userId,
    role
  }: {
    accessToken: string
    userId: string
    role: string
  }): boolean => {
    localStorage.setItem('accessToken', accessToken)
    localStorage.setItem('userId', userId)
    localStorage.setItem('role', role)
    window.location.reload()
    return true
  },
  signOut: () => {
    localStorage.clear()
    window.location.reload()
  }
}
